import { browserAndOsDetails } from "./BrowserAndOsDetails";

export const userSaveDetails = (accessed_item) => {
  return [
    sessionStorage.getItem("mwerezi_mpos_username"),
    accessed_item,
    browserAndOsDetails()[0],
    browserAndOsDetails()[1],
  ];
};
